import React from 'react';
import { useAppSelector, useAppDispatch, useAppStore } from '../../app/hooks';
import SkillItem from './SkillItem';
import { show as showToast } from '../toast/toastSlice';
import { show as showSkillPrac } from './skillPracSlice';

import { copy } from '../../services/util';
import { Skill } from '../../models/skill';

function SkillList() {
  const store = useAppStore();
  const dispatch = useAppDispatch();
  const skills = useAppSelector(state => state.skillTrainer.skills);
  const separator = useAppSelector(state => state.common.separator);

  const col1 = skills.filter(x => x.professionId === 'warrior' && !x.defunct);
  const col2 = skills.filter(x => x.professionId === 'rogue' && !x.defunct);
  const col3 = skills.filter(x => x.professionId === 'hunter' && !x.defunct);
  const col4 = skills.filter(x => x.professionId === 'fade' && !x.defunct);
  const col5 = skills.filter(x => x.defunct);

  const handleCopyClick = (e: React.MouseEvent, professionId: string) => {
    e.preventDefault();
    const { residualOrderType, commands } = store.getState().skillTrainer;
    if (!residualOrderType) {
      const commandsText = commands[professionId];
      const text = separator?.trim() ? commandsText.split('\n').join(separator) : commandsText;
      copy(text);
      dispatch(showToast('Copied to clipboard.'));
    } else {
      dispatch(showSkillPrac(professionId));
    }
  }

  const handleViewClick = (e: React.MouseEvent, professionId: string) => {
    e.preventDefault();
    dispatch(showSkillPrac(professionId));
  }

  const getChild = (skill: Skill) => {
    return (
      <SkillItem key={skill.id}
        id={skill.id}
        name={skill.name}        
        percentStart={skill.percentStart}
        percentTarget={skill.percentTarget}
        percentActual={skill.percentActual}
        pracsActual={skill.pracsActual}
        useLevel={skill.useLevel}
        busy={skill.busy} />
    );
  }

  return (
    <div className="skill-list">
      <div className="row g-0">
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell">
            <div className="group-title">
              <h6 className="me-3 my-0">WARRIOR</h6>
              <a className="text-decoration-none" href="/#" onClick={e => handleCopyClick(e, 'warrior')}>Copy</a>
              <div className="small mx-2 text-light">|</div>
              <a className="text-decoration-none" href="/#" onClick={e => handleViewClick(e, 'warrior')}>View</a>
            </div>
            <div className="group-list">
              {col1.map(skill => getChild(skill))}
            </div>
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell">
            <div className="group-title">
              <h6 className="me-3 my-0">ROGUE</h6>
              <a className="text-decoration-none" href="/#" onClick={e => handleCopyClick(e, 'rogue')}>Copy</a>
              <div className="small mx-2 text-light">|</div>
              <a className="text-decoration-none" href="/#" onClick={e => handleViewClick(e, 'rogue')}>View</a>
            </div>
            <div className="group-list">
              {col2.map(skill => getChild(skill))}
            </div>
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell">
            <div className="group-title">
              <h6 className="me-3 my-0">HUNTER</h6>
              <a className="text-decoration-none" href="/#" onClick={e => handleCopyClick(e, 'hunter')}>Copy</a>
              <div className="small mx-2 text-light">|</div>
              <a className="text-decoration-none" href="/#" onClick={e => handleViewClick(e, 'hunter')}>View</a>
            </div>
            <div className="group-list">
              {col3.map(skill => getChild(skill))}
            </div>
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell">
            <div className="group-title">
              <h6 className="me-3 my-0">FADE</h6>
              <a className="text-decoration-none" href="/#" onClick={e => handleCopyClick(e, 'fade')}>Copy</a>
              <div className="small mx-2 text-light">|</div>
              <a className="text-decoration-none" href="/#" onClick={e => handleViewClick(e, 'fade')}>View</a>
            </div>
            <div className="group-list">
              {col4.map(skill => getChild(skill))}
            </div>
          </div>
          {(col5.length && (
            <div className="cell">
              <div className="group-title">
                <h6 className="me-3 my-0">DEFUNCT</h6>
              </div>
              <div className="group-list">
                {col5.map(skill => getChild(skill))}
              </div>
            </div>
          )) || null}
        </div>
      </div>
    </div>
  );
}

export default SkillList;
